export const originalPriceStyle = {
  marginRight: '8px',
};

export const priceWithDiscountStyle = {
  marginRight: '8px',
};
